import React                    from 'react';
import { useTranslation }       from 'react-i18next';

export default function ActivitiesNoResult() {
    const { t } = useTranslation();
    return (
        <div className={ 'text-center p-2 ' }><h5>{ t('Dashboard.noActions') }</h5></div>
    );
}
